import { useCompoundBody } from "@react-three/cannon";
import { useRef } from "react";
import { Group } from "three";
import { Cylinder, ObjectProps, useDragConstraint } from "../utils";

export default ({position, rotation}: ObjectProps) => {
  const [ref] = useCompoundBody(() => ({
    mass: 5,
    position: position ?? [0, 0, 0],
    rotation: rotation ?? [0, 0, 0],
    shapes: [
      { args: [1.3, 1.1, 2, 16], mass: 5, position: [0, 0, 0], type: 'Cylinder' }
    ], 
    type: 'Dynamic',
  }), useRef<Group>(null));
  const bind = {}; // useDragConstraint(ref);
  return (
    <group ref={ref} {...bind}>
      <Cylinder position={[0, 0, 0]} args={[1.3, 1.1, 2, 16]} />
      <Cylinder position={[0, 0.01, 0]} args={[1, 0, 2, 16]} color="#2a2a2a" />
    </group>
  );
};
